const Play = ({ ...props }) => {
  return (
    <>
      <div className="hidden md:block">
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_5660_108040)">
            <mask
              id="mask0_5660_108040"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="6"
              y="6"
              width="68"
              height="68"
            >
              <path
                d="M40.0003 6.66669C21.6003 6.66669 6.66699 21.6 6.66699 40C6.66699 58.4 21.6003 73.3334 40.0003 73.3334C58.4003 73.3334 73.3337 58.4 73.3337 40C73.3337 21.6 58.4003 6.66669 40.0003 6.66669ZM33.3337 55V25L53.3337 40L33.3337 55Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_5660_108040)">
              <path
                d="M40.0003 6.66669C21.6003 6.66669 6.66699 21.6 6.66699 40C6.66699 58.4 21.6003 73.3334 40.0003 73.3334C58.4003 73.3334 73.3337 58.4 73.3337 40C73.3337 21.6 58.4003 6.66669 40.0003 6.66669ZM33.3337 55V25L53.3337 40L33.3337 55Z"
                fill="white"
              />
              <path d="M80 0H0V80H80V0Z" fill="white" />
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_5660_108040">
              <rect width="80" height="80" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="block md:hidden">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_5806_1777"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="3"
            y="3"
            width="34"
            height="34"
          >
            <path
              d="M19.9997 3.33337C10.7997 3.33337 3.33301 10.8 3.33301 20C3.33301 29.2 10.7997 36.6667 19.9997 36.6667C29.1997 36.6667 36.6663 29.2 36.6663 20C36.6663 10.8 29.1997 3.33337 19.9997 3.33337ZM16.6663 27.5V12.5L26.6663 20L16.6663 27.5Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_5806_1777)">
            <path
              d="M19.9997 3.33337C10.7997 3.33337 3.33301 10.8 3.33301 20C3.33301 29.2 10.7997 36.6667 19.9997 36.6667C29.1997 36.6667 36.6663 29.2 36.6663 20C36.6663 10.8 29.1997 3.33337 19.9997 3.33337ZM16.6663 27.5V12.5L26.6663 20L16.6663 27.5Z"
              fill="white"
            />
            <path d="M40 0H0V40H40V0Z" fill="white" />
            <path d="M40 0H0V40H40V0Z" fill="white" />
          </g>
        </svg>
      </div>
    </>
  )
}

export default Play
